import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appleStoreLink: "",
  googlePlayLink: "",
  isLoaderActive: false,
};

export const siteSettingsSlice = createSlice({
  name: "siteSettings",
  initialState,
  reducers: {
    setAppLinkButtons: (state, action) => {
      state.appleStoreLink = action.payload.appleStoreLink;
      state.googlePlayLink = action.payload.googlePlayLink;
    },
    setLoaderActive: (state, action) => {
      state.isLoaderActive = action.payload;
    },
  },
});

export const { setAppLinkButtons, setLoaderActive } = siteSettingsSlice.actions;

export default siteSettingsSlice.reducer;
